import { MessageHandler } from './type';

declare global {
  interface Window {
    AndroidTraveler: Record<string, any>;
    webkit: MessageHandler;
  }
}

function callAndroidNativeHandler(methodName: string, params: Record<string, any>) {
  const hasNativeHandler = typeof window.AndroidTraveler[methodName] === 'function';

  if (!hasNativeHandler) {
    return;
  }

  try {
    const stringifiedParams = typeof params === 'string' ? params : JSON.stringify(params);

    window.AndroidTraveler[methodName](stringifiedParams);
  } catch (error) {
    console.error(`failed to call native handler ${methodName}`, error);
  }
}

function callIosNativeHandler(methodName: string, params: Record<string, any>) {
  try {
    const handler = window.webkit?.messageHandlers?.[methodName];

    if (!handler || typeof handler.postMessage !== 'function') {
      return;
    }

    const stringifiedParams = typeof params === 'string' ? params : JSON.stringify(params);

    handler.postMessage(stringifiedParams);
  } catch (error) {
    console.error(`failed to call native handler ${methodName}`, error);
  }
}

export function callNativeHandler(methodName: string, params = {}) {
  try {
    if (window.AndroidTraveler) {
      callAndroidNativeHandler(methodName, params);
    } else if (window.webkit?.messageHandlers) {
      callIosNativeHandler(methodName, params);
    }
  } catch (error) {
    console.error(
      `callNativeHandler skipped due to non-standard environment: ${methodName}`,
      error,
    );
  }
}
